import * as React from 'react';
import { Result } from 'antd';
import './NotFoundPage.scss';
import { FrontLayout } from 'client/ui/layout/FrontLayout';

export interface INotFoundPageProps {}

export function NotFoundPage(props: INotFoundPageProps) {
  return (
    <FrontLayout>
      <Result status="error" title="404" subTitle="Pagina Non Trovata." />
    </FrontLayout>
  );
}
